(function () {
  function getQtyInput(sectionId, formId) {
    return (
      document.querySelector('#Quantity-' + sectionId) ||
      document.querySelector('form#' + formId + ' input[name="quantity"]') ||
      document.querySelector('.product-form input[name="quantity"]')
    );
  }

  function getSelectedQty(root) {
    const selected =
      root.querySelector('.product-qty-packs__card.is-selected') ||
      root.querySelector('.product-qty-packs__card');
    return parseInt(selected?.dataset.qty || '1', 10);
  }

  function initPackGroup(root) {
    const sectionId = root.dataset.sectionId;
    const formId = root.dataset.formId;
    const cards = root.querySelectorAll('.product-qty-packs__card');
    if (!cards.length) return;

    const qtyInput = getQtyInput(sectionId, formId);
    const productForm = document.querySelector('form#' + formId);

    function applyQty(qty) {
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.setAttribute('value', qty);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      applyQty(parseInt(card.dataset.qty || '1', 10));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    const selected = root.querySelector('.product-qty-packs__card.is-selected') || cards[0];
    if (selected) selectCard(selected);

    if (productForm) {
      productForm.addEventListener('submit', function () {
        applyQty(getSelectedQty(root));
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-qty-packs').forEach(initPackGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
